export default __webpack_public_path__ + "static/medicalAestheticsv2-7c40aafa5de68c9f52b798a43e1a6078.png";